import { Theme } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import Markdown from 'react-markdown';
import CodeBlock from './code-block';

interface Props {
  message: string;
}

const H1_FONT_SIZE = 18;

const useStyles = createUseStyles((theme: Theme) => ({
  markdownContent: {
    fontSize: theme.typography.body2.fontSize,
    overflowWrap: 'break-word',
    textWrap: 'wrap',
    wordBreak: 'break-word',
    '& p, pre, ol, ul': {
      margin: '8px 0',
    },
    '& h1, h2, h3, h4, h5, h6': {
      margin: '4px 0',
    },
    '& h1': {
      fontSize: H1_FONT_SIZE,
    },
    '& h2': {
      fontSize: H1_FONT_SIZE - 2,
    },
    '& h3': {
      fontSize: H1_FONT_SIZE - 4,
    },
    '& h4': {
      fontSize: H1_FONT_SIZE - 6,
    },
    '& h5': {
      fontSize: H1_FONT_SIZE - 8,
    },
    '& h6': {
      fontSize: H1_FONT_SIZE - 10,
    },
    '& > :first-child': {
      marginTop: 0,
    },
  },
}));

const MarkdownContent: FC<Props> = ({ message }) => {
  const styles = useStyles();
  return (
    <Markdown
      className={styles.markdownContent}
      components={{
        code: CodeBlock,
      }}
    >
      {message}
    </Markdown>
  );
};
export default MarkdownContent;
